import(/* webpackMode: "eager" */ "/home/sumeet/webdesign/prateeksha.com/nextjs-live/node_modules/.pnpm/next@14.2.28_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.86.3/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/sumeet/webdesign/prateeksha.com/nextjs-live/node_modules/.pnpm/next@14.2.28_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.86.3/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/sumeet/webdesign/prateeksha.com/nextjs-live/node_modules/.pnpm/next@14.2.28_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.86.3/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/home/sumeet/webdesign/prateeksha.com/nextjs-live/src/components/CallToAction.jsx");
;
import(/* webpackMode: "eager" */ "/home/sumeet/webdesign/prateeksha.com/nextjs-live/src/components/CallToBoost.jsx");
;
import(/* webpackMode: "eager" */ "/home/sumeet/webdesign/prateeksha.com/nextjs-live/src/components/CounterSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/sumeet/webdesign/prateeksha.com/nextjs-live/src/components/FaqsSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/sumeet/webdesign/prateeksha.com/nextjs-live/src/components/FormContactUs.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/sumeet/webdesign/prateeksha.com/nextjs-live/src/components/HeroSection.jsx");
;
import(/* webpackMode: "eager" */ "/home/sumeet/webdesign/prateeksha.com/nextjs-live/src/components/ImageBox.js");
;
import(/* webpackMode: "eager" */ "/home/sumeet/webdesign/prateeksha.com/nextjs-live/src/components/LatestBlog.js");
;
import(/* webpackMode: "eager" */ "/home/sumeet/webdesign/prateeksha.com/nextjs-live/src/components/PortfolioWebDesign.jsx");
;
import(/* webpackMode: "eager" */ "/home/sumeet/webdesign/prateeksha.com/nextjs-live/src/components/Services.jsx");
;
import(/* webpackMode: "eager" */ "/home/sumeet/webdesign/prateeksha.com/nextjs-live/src/components/TechnologySection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/sumeet/webdesign/prateeksha.com/nextjs-live/src/components/WhatIsIncludedSection.jsx");
;
import(/* webpackMode: "eager" */ "/home/sumeet/webdesign/prateeksha.com/nextjs-live/src/components/WhyChooseUsSection.jsx");
